export type ComponentStatusCheck = {
  componentStatusCheckId: string;
  name: string;
  groupName: string;
  ordinal: number;
  componentUrl: string;
  componentType: ComponentStatusCheckTypes;
  isLoadingStatus: boolean;
  statusResult: ComponentStatusCheckResult | undefined;
};

export type ComponentStatusCheckResult = {
  componentStatusCheckId: string;
  status: ComponentStatus;
  durationMS: string;
  buildVersion: string;
  buildDate: string;
  details: string;
};

export enum ComponentStatusCheckTypes {
  Other = 'Other',
  API = 'Api',
  CLIENT = 'Client',
}

export enum ComponentStatus {
  Unknown = 'Unknown',
  Healthy = 'Healthy',
  Unhealthy = 'Unhealthy',
}
